<template>
    <v-dialog v-model="add" max-width="700px" persistent>
        <v-card class="pa-3">
            <v-card-title class="primary elevation-4">
                <span class="headline white--text">Add New Wholesaler</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>

                        <v-flex xs12 sm6 md4>

                            <ValidationProvider name="IseekId" rules="required" v-slot="{ errors }">

                                <v-text-field
                                        label="IseekId"
                                        name="IseekId"
                                        :error-messages="errors"
                                        v-model="editedItem.iseekId"
                                ></v-text-field>

                            </ValidationProvider>

                        </v-flex>

                        <v-flex xs12 sm6 md4>

                            <ValidationProvider name="Name" rules="required" v-slot="{ errors }">

                                <v-text-field
                                        label="Name"
                                        name="Name"
                                        :error-messages="errors"
                                        v-model="editedItem.name"
                                ></v-text-field>

                            </ValidationProvider>

                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save()">Save</v-btn>
                <v-btn color="light-grey" @click="cancel()">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "AddIseekWholesaler",
        data () {
            return {
                editedItem: {
                    iseekId: 0,
                    name:"",
                }
            };
        },
        props: {
            add: { type: Boolean, required: true }
        },
        methods: {
            cancel () {
                this.$emit("close");
            },
            save () {
                this.$emit("save", this.editedItem);
            }
        }
    };
</script>
